<template>
  <div class="axj-competition-main">
    <el-table ref="refTable"
              @row-click="expandRow"
              style="width: 100%"
              :data="data"
              :row-class-name="rowClassName"
              :expand-row-keys="expands"
              :row-key='getRowKeys'
    >
      <el-table-column type="expand" >
        <template slot-scope="{row}">
          <el-form label-position="left"  label-width="110px" class="demo-table-expand" style="margin-left: 10px">
            <el-form-item style="margin-top: -20px"  label="发布时间" >
              {{ row.create_time|parseTime}}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="赛事状态" >
              {{parseInt((new Date()).getTime()/1000)<=row.competition_start_time?'未开始':parseInt((new Date()).getTime()/1000)>row.competition_end_time?'比赛结束':'进行中'}}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="赛事名称" >
              {{row.title}}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="主办方" >
              {{ row.sponsor }}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="承办方" >
              {{ row.organizer }}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="赛事级别" >
              {{ row.competition_level==0?'国家级':row.competition_level==1?'省级':row.competition_level==2?'校级':'其它' }}
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="报名时间" >
              <div class="axj-show-club-main-content">
                {{row.signup_start_time|parseTime}}&nbsp;至&nbsp;{{row.signup_end_time|parseTime}}
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="比赛时间" >
              <div class="axj-show-club-main-content">
                {{row.competition_start_time|parseTime}}&nbsp;至&nbsp;{{row.competition_end_time|parseTime}}
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="报名人数" >
              <el-button  type="primary" plain size="mini" @click="handleShowTakers(row)">{{row.participant_sum}}</el-button>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="浏览" >
              <div class="axj-show-club-main-content">
                {{row.read_sum}}
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="关注" >
              <div class="axj-show-club-main-content">
                {{row.follow_sum}}
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="赛事简介" >
              <div class="axj-show-club-main-content">
                {{row.content}}
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="附件" >
              <div class="post-main-images" >
                <div :class="'post-main-word'" v-for="x in fileList" :key="x.id">
                  <ul @click="previewWord(x)" class="el-upload-list el-upload-list--text">
                    <li tabindex="0" class="el-upload-list__item is-success">
                      <a class="el-upload-list__item-name">
                        <i class="el-icon-document"></i>
                        {{x.name}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="通知公告" >
              <div class="axj-show-club-main-announce-list">
                <el-collapse class="axj-show-club-main-announce" v-model="activeNames" @change="handleChange">
                  <el-collapse-item :title="x.title" :name="x.id" v-for="x in announceList" :key="x.id">
                    <div>{{x.content}}</div>
                  </el-collapse-item>
                </el-collapse>
              </div>

            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="直击现场" >
              <div class="axj-show-club-main-article-list">
                <div class="axj-show-club-main-article" v-for="x in articleList" :key="x.id">
                  <div class="article-title">
                    {{x.content}}
                  </div>
                  <div class="article-images">
                    <img :src="preViewUrl+y.url" v-for="y in x.Thumbs" >
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="发布时间"  width="160px" prop="time">
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}

        </template>
      </el-table-column>
      <el-table-column label="赛事状态" show-overflow-tooltip  width="100px" >
        <template slot-scope="{row}">
          {{parseInt((new Date()).getTime()/1000)<=row.competition_start_time?'未开始':parseInt((new Date()).getTime()/1000)>row.competition_end_time?'比赛结束':'进行中'}}
        </template>
      </el-table-column>
      <el-table-column label="赛事名称" show-overflow-tooltip  width="240px" prop="title">

      </el-table-column>
      <el-table-column label="报名人数"  width="100px" prop="participant_sum">

      </el-table-column>
      <el-table-column label="浏览"  width="100px" prop="read_sum">

      </el-table-column>
      <el-table-column label="关注"  width="100px" prop="follow_sum">

      </el-table-column>
      <el-table-column   label="操作">
        <template slot-scope="{row}">
          <axj-button-v2
            button-color="bread"
            button-size="medium"
            button-icon="del1"
            @click="handleDelete(row.id)"
          ></axj-button-v2>
          <axj-button-v2
            button-icon="edit1"
            @click="handleUpdate(row.id)"
          ></axj-button-v2>
        </template>
      </el-table-column>
    </el-table>
    <axj-file-preview
      :show-preview.sync="preview.show"
      :preview-file-type="preview.previewFileType"
      :preview-files="preview.previewFiles"
    />
    <takers
      :show.sync="takers.show"
      :competition-id="takers.competitionId"
    />
  </div>
</template>
<script>

import AxjButton from "../../../../../components/axj-button/index";
import commonModels from '@/common/models/common-models'
import common from '@/common/common'
import AxjButtonV2 from "../../../../../components/common/button/axj-button";
import Takers from "../takers/index";
export default {
  name: "show-club-main",
  components: {Takers, AxjButtonV2, AxjButton},
  props:{
    data:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  watch:{
    data(v){

    }
  },
  methods:{
    handleDelete(id){
      this.$emit("delete",id)
    },
    handleShowTakers(row){
      console.log(111)
      this.takers.show=true
      this.takers.competitionId=row.id
    },
    listCompetitionClubFile(row){
      this.$api.axjExtracurricularApi.competitionClub.listCompetitionClubFile({
        where: JSON.stringify({
          competition_id: row.id
        }),
        preload:true
      }).then(res=>{
        this.fileList=res.data.lists
      },error => {
      })
    },
    previewWord(x){
      this.preview.previewFileType='image'
      this.preview.previewFiles=[]
      this.preview.previewFiles.push({
        url:x.url
      })
      this.preview.show=true
    },
    listCompetitionClubArticle(row){
      this.$api.axjExtracurricularApi.competitionClub.listCompetitionClubArticle({
        where: JSON.stringify({
          competition_id: row.id
        }),
        preload:true
      }).then(res=>{
        this.articleList=res.data.lists
      },error => {
      })
    },
    getRowKeys(row){
      return row.id
    },
    handlePlayVideo(row) {
      if(row.video_url) {
        let url = row.video_url.indexOf('http')>=0?row.video_url:this.resourcePrefix.url+row.video_url
        this.video.url = url
        this.showLovePlayer = true
      }
    },

    listCompetitionClubNotice(row){
      this.$api.axjExtracurricularApi.competitionClub.listCompetitionClubNotice({
        where: JSON.stringify({
          competition_id: row.id
        }),
        preload:true
      }).then(res=>{
        this.announceList=res.data.lists
      },error => {

      })
    },
    handleUpdate(v){
      this.$emit('update',v)
    },
    expandRow(row,index,e){
      let tempExpands=this.expands
      this.expands=[]
      let target=e.target
      if(target.className.indexOf('cell')==0||target.className.indexOf('el-tag')==0||target.className.indexOf('el-table')==0){
        if(tempExpands.indexOf(row.id)==-1){
          this.expands.push(row.id)
          this.listCompetitionClubNotice(row)
          this.listCompetitionClubArticle(row)
          this.listCompetitionClubFile(row)
        }else{
          this.expands.pop()
        }
        return
      }
    },
    rowClassName({row, rowIndex}){
      row.index=rowIndex
      // if(rowIndex%2==0){
      //   return "while-row"
      // }else{
      //   return "gray-row"
      // }
    },
    handleChange(val) {
      console.log(val);
    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D')
    },
    arrayImg(v,x){
      let preViewUrl=common.SystemConfig.PreViewUrl
      let array=[]
      for (let i =0 ;i<v.length;i++){
        if(v[i].url===x.url){
          let temp=array[0]
          array[0]=preViewUrl+x.url
          array.push(temp)
        }else{
          array.push(preViewUrl+v[i].url)
        }
      }
      return array
    }
  },
  data(){
    return{
      activeNames: ['1'],
      showLovePlayer: false,
      video: {
        url : '',
      },
      takers:{
        show:false,
        competitionId:undefined
      },
      expands:[],
      announceList:[],
      articleList:[],
      fileList:[],
      preview:{
        show:false,
        previewFileType:'word',
        previewFiles:[]
      }
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-competition-main{
  .el-tag,.el-tag--info {
    background-color: #41555d;
    /* border-color: #e9e9eb; */
    color: #ffffff;
  }
  .el-table__body tr:hover>td{
    background-color: #f2f5f8 !important;
  }
  .el-table__body tr.current-row>td{
    background-color: #f2f5f8 !important;
  }
  .axj-show-club-main-announce-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .axj-show-club-main-announce{
      width: 630.888px;
      margin-right: 10px;
      margin-top: 12.26px;
    }
  }
  .axj-show-club-main-article-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    .axj-show-club-main-article{
      width: 630.888px;
      margin-right: 10px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, .08), 0 0 4px rgba(0, 0, 0, .04);
      margin-top: 10px;
      padding-left: 10px;
      img{
        margin-right: 10px;
        width: 55px;
        height: 55px;
      }
    }
  }
  .axj-show-club-main-content{
    line-height: 20px;
    margin-top: 9px;
  }
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .while-row {
    background: #ffffff;
  }
  .el-table .gray-row {
    background: #e8eef0;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .info-row{
    background: #D6D8DC;
  }
  .axj-competition-main-images{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .axj-competition-main-dio{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      img{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .axj-competition-main-image{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      .el-image{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .axj-competition-main-image:not(:first-child){
      margin-left: 30.5px;
    }
    .axj-competition-main-image:nth-child(5n+6){
      margin-left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-extracurricular/axj-competition-club/component/axj-competition-main/index.vue